<template>
  <div class="container h-full">
    <div>
      <h1>Company Settings</h1>
      <div>
        <v-switch
          :loading="loading"
          v-model="videoControls"
          label="Show Video Controls"
          color="red"
          hide-details
          @change="updateSettings"
        >
        </v-switch>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoControls: false,
      loading: false,
    };
  },
  methods: {
    updateSettings() {
      this.loading = true;
      this.axios
        .post('/company-settings/settings', {
          dealerId: this.user.dealer.id,
          videoControls: this.videoControls,
        })
        .then(({ data }) => {
          this.$notify('success', 'Company Settings Saved');
          this.loading = false;
        })
        .catch((data) => {
          this.$notify('error', 'Company Settings Failed');
        });
    },
    getSettings() {
      this.loading = true;

      this.axios.get('/company-settings/settings').then(({ data }) => {
        this.videoControls = data.settings.video_controls;
        this.loading = false;
      });
    },
  },
  computed: {
    user() {
      return this.$auth.user();
    },
  },
  created() {
    this.getSettings();
  },
};
</script>
